import { connect } from 'react-redux'
import { IStoreState, IMobilityOptionObject } from '../../types/index'
import {
  getMobilityOptions,
  getMobilityOptionCategories,
  updateMobilityOption,
  removeMobilityOption
} from 'src/state/actions/mobility-options'
import RemoveMobilityDeviceModal from 'src/components/global-settings/RemoveMobilityDeviceModal'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {
    devices: state.mobilityOptions.items
  }
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    remove: (mobility: IMobilityOptionObject) => {
      return dispatch(removeMobilityOption(mobility))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RemoveMobilityDeviceModal)



// WEBPACK FOOTER //
// ./src/containers/global-settings/RemoveMobilityDeviceModal.ts